/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * @fileoverview Complete helper functions for generating PHP for
 *     blocks.  This is the entrypoint for php_compressed.js.
 * @suppress {extraRequire}
 */
'use strict';

goog.module('Blockly.PHP.all');

const moduleExports = goog.require('Blockly.PHP');
goog.require('Blockly.PHP.colour');
goog.require('Blockly.PHP.lists');
goog.require('Blockly.PHP.logic');
goog.require('Blockly.PHP.loops');
goog.require('Blockly.PHP.math');
goog.require('Blockly.PHP.procedures');
goog.require('Blockly.PHP.texts');
goog.require('Blockly.PHP.variables');
goog.require('Blockly.PHP.variablesDynamic');

exports = moduleExports;
